"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MenuItemButton_module_css_1 = __importDefault(require("./MenuItemButton.module.css"));
/**
 * Item button used in Menu list.
 */
function MenuItemButton({ children, onClick }) {
    return ((0, jsx_runtime_1.jsx)("div", { className: MenuItemButton_module_css_1.default.menuItem, onClick: onClick, role: "button", children: children }));
}
exports.MenuItemButton = MenuItemButton;
//# sourceMappingURL=MenuItemButton.js.map